import {useContext, useState} from "react";
import classes from "../layout/MainNavigationTop.module.scss";
import captainHatIcon from "../../images/icons/captain_hat.svg";
import {Link} from "react-router-dom";
import UserContext from "../../store/userContext";
import HeartIcon from "../../svg/HeartIcon";
import BellIcon from "../../svg/BellIcon";
import CaptainHatIcon from "../../svg/CaptainHatIcon";

export default function MinSideMenu(){
	const [isModalOpen, setIsModalOpen] = useState(false)
	const userContext = useContext(UserContext);

	const isMobile = window.innerWidth < 768;

	function Menu(){return(<>
			<div className={'linkList'} onClick={()=>setIsModalOpen(false)}>
				<Link to={'/min-side/favoritter'}><HeartIcon fill={'transparent'}/>Favoritter</Link>
				<Link to={'/min-side/varsler'}><BellIcon/>Varsler</Link>
				<Link to={'/min-side'}><CaptainHatIcon fill={'currentColor'}/>Min Side</Link>
			</div>
	</>)}

	function Wrapper({children}) {
		if(!userContext.isLoggedIn) return <Link to={userContext.isLoggedIn ? "/min-side" : "/login"}
											   className={['noLink', classes.navSpacer, classes.personContainer].join(' ')}>
			{children}
		</Link>
		return <div className={['noLink', classes.navSpacer, classes.personContainer].join(' ')}
		   onClick={() => setIsModalOpen(!isModalOpen)}>
			{children}
		</div>
	}

	return (<>
		<Wrapper>
			<div style={{display: 'contents', position: 'relative'}}>
				<div className={classes.personIconContainer}
					 style={userContext.isLoggedIn ? {filter: 'brightness(1)'}
						 : {backgroundImage: `url(${captainHatIcon})`}}>
					<div>{userContext.name && userContext.name[0]}</div>
				</div>
			</div>
		</Wrapper>

		<div className={['minSideMenu', isModalOpen ? '' : 'hidden'].join(' ')}>
			<Menu />
		</div>
	</>)}